import { useState } from "react";
import { useTranslation } from 'react-i18next';
import { saveQuestionReview } from "../../../api/questionAPIs";

const MessageReview = ({id}) => {

    const [t, ] = useTranslation('global');
    const [review, setReview] = useState('');
    const [reviewSubmitted, setReviewSubmitted] = useState(false);

    const handleSubmit = () => {
        saveQuestionReview(id, review);
        setReviewSubmitted(true);
    }

    return (
        <div className="review-container">
            {reviewSubmitted? null :
                <>
                <input 
                    type="text"
                    className="input-review"
                    name="inputReview"
                    value={review}
                    onChange={(e) => setReview(e.target.value)}
                    placeholder={t('enterReview')}           
                />
                <span id="rate-my-answer-icon" className="send-review material-symbols-outlined" 
                    onClick={handleSubmit}>
                    arrow_upward
                </span>
                </>
            }
            {reviewSubmitted? <span>Review sent</span> : null}
        </div>
    );
}

export default MessageReview;